import { t } from "@lingui/core/macro";
import { getSupportedNetworks } from "../../../shared/utils/asset-config";

// App metadata configuration
export const APP_METADATA = {
  get name() {
    return t`Blockdaemon Widget`;
  },
  get description() {
    return t`Blockdaemon Widget`;
  },
  url: typeof window !== "undefined" ? window.location.origin : "https://widget.blockdaemon.com",
  icons: ["/icon.png"] as string[],
};

// Network configuration
const SUPPORTED_NETWORKS = getSupportedNetworks();

export const NETWORK_CONFIG = {
  supportedNetworks: SUPPORTED_NETWORKS,
  defaultChainId: SUPPORTED_NETWORKS[0].id,
  defaultNamespace: SUPPORTED_NETWORKS[0].chainNamespace,
  // Note: AppKit uses `caipNetworkId` in its CaipNetwork type.
  // This is mapped to our internal `caip2ChainId` property in WalletAccount.
  defaultChainNetworkId: SUPPORTED_NETWORKS[0].caipNetworkId,
} as const;

// Optional custom chain logo overrides (used by AppKit modal)
// Keys are EVM chain IDs; values are image URLs (absolute/relative/data URI)
// Only Kaia is customized; others rely on AppKit presets.
export const CHAIN_IMAGES: Record<number, string> = {
  // Kaia (mainnet)
  8217: "https://images.ctfassets.net/hwqnbx905qdp/4iCRTo0HIdsTGoeV5MgKjr/33a77f98f0c58effdaacfdd1bf0c29e9/kaia-kaia-logo.svg",
};

// AppKit configuration
const APPKIT_CONFIG = {
  features: {
    analytics: false,
    socials: false,
    email: false,
    emailShowWallets: false,
    onramp: false,
    swaps: false,
    history: false,
  },
  themeVariables: {
    "--w3m-color-mix": "var(--mantine-color-gray-4)",
  },
  termsConditionsUrl: "https://www.blockdaemon.com/terms-and-conditions",
  privacyPolicyUrl: "https://www.blockdaemon.com/privacy-policy",
} as const;

// Simple functions instead of class methods
export function getProjectId(): string | undefined {
  return import.meta.env.VITE_WALLETCONNECT_PROJECT_ID;
}

// Complete AppKit configuration
export function getAppKitConfig() {
  const projectId = getProjectId();

  return {
    adapters: [], // Will be set by the adapter
    networks: SUPPORTED_NETWORKS,
    projectId: projectId || "",
    metadata: APP_METADATA,
    features: APPKIT_CONFIG.features,
    themeVariables: APPKIT_CONFIG.themeVariables,
    termsConditionsUrl: APPKIT_CONFIG.termsConditionsUrl,
    privacyPolicyUrl: APPKIT_CONFIG.privacyPolicyUrl,
  };
}
